const FIELD_MASK = 'clientData';
export const buildPricingPlansBulkUpdatePayload = (altTextData, plansMap) => {
  const payload = [];
  altTextData.forEach(_ref => {
    let {
      id,
      alt
    } = _ref;
    const originalPlan = plansMap.get(id ?? '');
    if (!originalPlan) {
      return;
    }
    let coverImageData;
    try {
      var _originalPlan$clientD;
      coverImageData = (_originalPlan$clientD = originalPlan.clientData) != null && _originalPlan$clientD.coverImage ? JSON.parse(originalPlan.clientData.coverImage) : {};
    } catch (error) {
      coverImageData = {};
    }

    // Create updated plan with new client data
    const updatedPlan = {
      ...originalPlan,
      clientData: {
        ...originalPlan.clientData,
        coverImage: JSON.stringify({
          ...coverImageData,
          altText: alt
        })
      }
    };
    payload.push({
      fieldMask: [FIELD_MASK],
      plan: updatedPlan
    });
  });
  return payload;
};
//# sourceMappingURL=bulk-update-pricing-plans-alt-update-payload-builder.js.map